import request from '@/utils/request'; // 获取广告位列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/advertisement/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/advertisement/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/advertisement/info',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/advertisement/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/advertisement/update',
    method: 'post',
    data: data
  });
}